export const device = () => {
  const u = navigator.userAgent;
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (isiOS) {
    return true
  } else {
    return false
  }
}

// 判断是否是移动端 (如果是外场UA，也不走映射)
export const isMobile = () => {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|outfield)/i
  );
  return flag;
}

export const isIOS = /iP(hone|od|ad)/i.test(navigator.userAgent || '')
